import { datadogRum } from '@datadog/browser-rum';

// Wrap an Axios client with this function
// to log request and response bodies to DD
const wrapAxios = (axios) => async (config) => {
  try {
    return await axios(config);
  } catch (e) {
    datadogRum.addError(e, {
      method: config.method,
      url: config.url,
      requestBody: config.data,
      responseBody: e?.response?.data,
    });
    throw e;
  }
};

export default wrapAxios;
